<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
    </div>

    <el-form 
      ref="form" 
      :model="form" 
      :rules="rules" 
      label-width="100px"
      label-position="right"
      :label-suffix="(type == 'preview' ? '：' : '')"
    >
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item label="上级部门" :class="{'mb-0':type == 'preview'}">
            <Treeselect
              v-if="type != 'preview'"
              :options="treeList"
              placeholder="请选择上级部门"
              noOptionsText="暂无数据"
              id="parentId"
              :normalizer="normalizer"
              v-model="form.parentId"
              :max-height="100"
            />
            <span v-else>{{ parseStrEmpty(form.parentName) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item
            label="部门名称"
            :class="{'mb-0':type == 'preview'}"
            :prop="type != 'preview' ? 'deptName' : ''"
          >
            <el-input 
              v-if="type != 'preview'"
              v-model="form.deptName" 
              placeholder="请输入" 
            ></el-input>
            <span v-else>{{ parseStrEmpty(form.deptName) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="type == 'preview'" class="form-operation">
        <el-col :span="12">
          <el-form-item
            label="操作人"
            class="mb-0"
          >
            <span>{{ parseStrEmpty(form.updateBy) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="操作时间"
            class="mb-0"
          >
            <span>{{ parseStrEmpty(form.updateTime) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { modifyDept } from '@/api/system/system'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  components: { Treeselect },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'deptName',
      },
      form: { 
        parentId: null,
        deptName: ''
      },
      rules: {
        deptName: [{ required: true, message: '请输入部门名称', trigger: 'blur' }],
      }
    }
  },
  computed:{
    ...mapState({treeList: state=>state.system.deptTreeList})
  },
  methods: {
    getDetails(row){
      if(row){
        if(this.type == 'save'){
          this.form = {
            id: null,
            parentId: row.id
          }
        }else{
          this.form = Object.assign(this.form,{
            ...row,
            parentId: row.parentId ? row.parentId : null
          })
        }
      }
    },
    submit(){
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            let result = await modifyDept(this.form, this.type)
            if(result.code == 200 && result.flag){
              this.$message.success('提交成功')
              resolve()
            }else{
              this.$message.error(result.message)
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    reset(){
      this.form.parentId = null
      this.form.deptName = ''
      this.resetForm('form')
    },
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.deptName,
        children: node.children,
      }
    },
    flatten(arr, key) {
      const res = [] // 结果数组
      arr.forEach((item) => {
        if (item[key]) {
          res.push(item, ...this.flatten(item[key], key)) // 递归
        } else {
          res.push(item)
        }
      })
      return res
    },
  },
}
</script>

<style scoped lang='less'>
@import '~@/assets/form.less';
</style>